module.exports = __webpack_public_path__ + "img/about-info-img1.8daf991c.jpg";